module.exports = __webpack_public_path__ + "img/ring_g_0_1_0.9a451de8.png";